import React, { memo, useEffect, useRef, useState } from 'react';
import type { FC, ReactNode } from 'react';
import LogoImg from '@/assets/images/logo-white.png';
import { useLocation, useNavigate } from 'react-router-dom';
import ToggleIcon from '../toggleIcon';
import './index.less';
import { useAppDispatch, useAppSelector } from '@/store';
import classnames from '@/utils/classnames';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Checkbox, Dropdown, MenuProps, Modal, message } from 'antd';
import { updateAccount } from '@/store/module/account';
import { clearToken } from '@/utils/cookie';
import AvatarImg from '@/assets/images/avatar.svg';
import dayjs from '@/utils/day';
import { logout } from '@/api/login';
import { POLICY } from '@/utils/constant';
const DelAccountContent = ({ submitChange }: { submitChange: () => void }) => {
  const [flag, setFlag] = useState(false);
  const deleteAccount = async () => {
    if (!flag) {
      message.warn(
        'Please read and confirm the instructions for deleting an account'
      );
      return;
    }
    const { success, msg } = await logout();
    if (success) {
      submitChange();
      message.success('Delete account successfully');
    } else {
      message.error(msg);
    }
  };

  return (
    <>
      <div>
        You can delete your account at any time. If you change your mind, you
        may not be able to recover it.
      </div>
      <div>Deleting your account means:</div>
      <div>-You’ll lose all the data and content in this account.</div>
      <div>
        -You won&apos;t be able to use
        <span className="notranslate">GVPN</span> services where you sign in
        with this account.
      </div>
      <div>
        -You’ll lose access to subscriptions you bought with this account.
      </div>
      <div className="checkBox">
        <Checkbox
          checked={flag}
          onChange={(e) => {
            setFlag(e.target.checked);
          }}
        >
          I have read and understood
        </Checkbox>
        <a href={POLICY.CANCELLATION} target="_blank" rel="noopener noreferrer">
          the instructions for deleting an account
        </a>
      </div>
      <div className="delBtn" onClick={deleteAccount}>
        Delete account
      </div>
    </>
  );
};

interface IProps {
  children?: ReactNode;
}

const AppHeader: FC<IProps> = () => {
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(true);

  const setBodyOverflow = (collapsed: boolean) => {
    const bodyElem = document.querySelector('body');
    bodyElem?.setAttribute(
      'style',
      `overflow: ${collapsed ? 'auto' : 'hidden'}`
    );
  };
  useEffect(() => {
    setBodyOverflow(collapsed);
  }, [collapsed]);

  useEffect(() => {
    // window.scrollTo(0, 0);

    const hash = location.hash;
    if (hash) {
      const elem = document.querySelector(hash);
      if (elem) {
        setTimeout(() => {
          elem.scrollIntoView({ behavior: 'smooth' });
        }, 200);
      }
    }
  }, []);

  return (
    <div className="header-container">
      <div className="container header-wrap">
        <div className="header-left">
          <img
            className="header-logo"
            src={LogoImg}
            onClick={() => {
              navigate('/');
            }}
          />
        </div>
        <div className="header-right">
          <ToggleIcon
            className="header-toggler"
            collapsed={collapsed}
            setCollapsed={setCollapsed}
          />
          <div className={classnames('header-nav', { collapsed })}>
            <ToggleIcon
              className="header-toggler"
              collapsed={collapsed}
              setCollapsed={setCollapsed}
            />

            <a
              className="nav-link"
              onClick={() => {
                setCollapsed(true);
                navigate('/home');
              }}
            >
              HOME
            </a>
            <a
              className="nav-link"
              onClick={() => {
                setCollapsed(true);
                navigate('/whyUs');
              }}
            >
              WHY US
            </a>

            {/* {!!accountInfo && (
              <a
                className={classnames('nav-link', 'userInfo', {
                  isSignin: !!accountInfo?.email
                })}
                onClick={() => {
                  showAccount();
                }}
              >
                Account
              </a>
            )} */}

            {/* <button
              className={classnames('signin-btn', 'nav-link', {
                isSignin: !!accountInfo?.email
              })}
              onClick={() => {
                if (accountInfo?.email) {
                  showSignout();
                } else {
                  setCollapsed(true);
                  setBodyOverflow(true);
                  navigate('/auth/signin');
                }
              }}
            >
              {accountInfo?.email ? 'Sign out' : 'Sign in'}
            </button> */}

            {/* {!!accountInfo && (
              <a
                className={classnames('nav-link', 'logout-btn', {
                  isSignin: !!accountInfo?.email
                })}
                onClick={() => {
                  showLogout();
                }}
              >
                Delete account
              </a>
            )} */}

            {/* {accountInfo?.email && (
              <>
                <Dropdown menu={{ items }} placement="bottom">
                  <img className="avatar" src={AvatarImg} alt="" />
                </Dropdown>
              </>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(AppHeader);
